/** biome-ignore-all lint/suspicious/noExplicitAny: <explanation> */
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import type React from 'react';
import { useState } from 'react';
import { login } from '../api/auth';
import { API_BASE_URL, GOOGLE_CLIENT_ID } from '../config';
import EEImage from '../assets/EE_Image.png';
import LoginForm from './LoginForm';

const OcidOauthFlow: React.FC = () => {
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [loginError, setLoginError] = useState<string | null>(null);

  const buildReturnUrl = () => {
    const rawQuery = window.location.search.replace(/^\?/, '');
    const remaining = rawQuery.split('&').filter((pair) => pair && !pair.startsWith('app_type='));
    return `/connect/authorize?${remaining.join('&')}`;
  };

  const submitToConnectLogin = (fields: Record<string, string>) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${API_BASE_URL}/connect/login`;
    form.style.display = 'none';

    const allFields: Record<string, string> = {
      returnUrl: buildReturnUrl(),
      ...fields,
    };

    for (const [name, value] of Object.entries(allFields)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
  };

  const handleLogin = ({ email, password }: { email: string; password: string }) => {
    setLoginError(null);
    setIsLoggingIn(true);
    submitToConnectLogin({ userName: email, password });
  };

  const handleGoogleLogin = async (credentialResponse: any) => {
    setLoginError(null);
    try {
      const googleIdToken = credentialResponse?.credential;
      if (!googleIdToken) throw new Error('No Google ID token received');

      setIsLoggingIn(true);
      const result = await login({ googleIdToken });
      if (!result.bearerToken) {
        throw new Error('Login failed - no bearer token received');
      }

      const continuation = new URLSearchParams(window.location.search).get('continue');
      const response = await fetch(`${API_BASE_URL}/api/identity/oidc/handoff`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${result.bearerToken}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ continuation }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || 'OIDC handoff failed');
      }

      const { handoff_url } = data;
      window.location.assign(`${API_BASE_URL}${handoff_url}`);
    } catch (error: any) {
      setLoginError(error instanceof Error ? error.message : 'Login failed. Please try again.');
      setIsLoggingIn(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '40px auto', padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'center', height: '100px' }}>
        <img src={EEImage} alt="Elastic Email logo" />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '-50px',
          marginTop: '30px',
        }}
      >
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <GoogleLogin
            onSuccess={handleGoogleLogin}
            onError={() => setLoginError('Login failed. Please try again.')}
            width="100%"
          />
        </GoogleOAuthProvider>
      </div>
      <LoginForm
        onLogin={handleLogin}
        onGoogleLogin={handleGoogleLogin}
        LoggedIn={false}
        visibility2FA={false}
        onVerify={() => {}}
        onResend={() => {}}
        redirectLogin={() => {}}
        rememberLogin={() => {}}
        onAuthorizeApp={() => {}}
        isLoading={isLoggingIn}
        enableGoogleLogin={false}
        appName="claude"
        loginError={loginError}
        twoFAError={null}
      />
    </div>
  );
};

export default OcidOauthFlow;
